import { INTERFACE_IDS } from '@lukso/lsp-smart-contracts'
import Eth from 'web3-eth'
import { ResultOrError } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { PopupDatabase } from '@/popup/storage/Database'
import { checkInterface } from '@/shared/checkInterface'
import { UpAddress } from '@/shared/models/Profile'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { t } from '@/popup/lib/i18n'

const validateUpAddress = async (
  web3Eth: Eth,
  address: UpAddress
): Promise<ResultOrError<boolean, Error>> => {
  try {
    const isUniversalProfile = await checkInterface(
      web3Eth,
      address,
      INTERFACE_IDS.LSP1UniversalReceiver
    )
    return ResultOrError.success(isUniversalProfile)
  } catch {
    return ResultOrError.error(
      new Error(
        t('errors.invalid_interface_address', {
          interface: 'LSP0ERC725Account',
        })
      )
    )
  }
}

const validateProfile = async (
  address: UpAddress
): Promise<ResultOrError<boolean, Error>> => {
  const { getWeb3Eth } = useWeb3Eth()
  const web3Eth = getWeb3Eth()
  const isUniversalProfileOrError = await validateUpAddress(web3Eth, address)
  if (!isUniversalProfileOrError.success) {
    return isUniversalProfileOrError
  }

  return ResultOrError.success(true)
}

export const validateUpImport = async (
  address: UpAddress
): Promise<ResultOrError<boolean, Error>> => {
  const profileOrError = await validateProfile(address)
  if (!profileOrError.success) {
    return profileOrError
  }

  return ResultOrError.success(true)
}

export const checkIfProfileIsImported = async (
  address: UpAddress
): Promise<ResultOrError<boolean, Error>> => {
  const popupProfileOrError = await PopupDatabase.getPopupProfile(address)
  const importStatus = popupProfileOrError?.temporary?.importStatus
  if (popupProfileOrError?.isOwner || importStatus === 'imported') {
    return ResultOrError.error(new Error(t('qr_code.scan.profile_exists')))
  }
  return ResultOrError.success(true)
}

export const validateUpRestore = async (address: UpAddress) => {
  const profileOrError = await validateProfile(address)
  if (!profileOrError.success) {
    return ResultOrError.error(profileOrError.error)
  }
  const popupProfileOrError = await PopupDatabase.getPopupProfile(address)
  const restoreStatus = popupProfileOrError?.temporary?.restoreStatus
  if (popupProfileOrError?.isOwner || restoreStatus === 'restored') {
    return ResultOrError.error(new Error(t('qr_code.scan.profile_exists')))
  }
  return ResultOrError.success(true)
}
